import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormTitleClassesDirective } from '../directives';

export type FormGroupTitlePosition = 'left' | 'top';
export type FormGroupTitleSize = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

@Component({
  selector: 'mbs-form-group',
  templateUrl: 'form-group.component.html',
  host: {
    '[class]': 'hostClasses()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormTitleClassesDirective]
})
export class FormGroupComponent {
  /**
   * Title text for a form group
   */
  public readonly title = input<string>(null);

  /**
   * Classes for title
   */
  public readonly titleClasses = input<string>(null);

  /**
   * Implements one of the title size
   * Possible values: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
   */
  public readonly titleSize = input<FormGroupTitleSize>('h5');

  public readonly titlePosition = input<FormGroupTitlePosition>('top');

  public readonly contentCustomClass = input<string>(null);

  protected readonly hostClasses = computed<string>(() => {
    const position = this.titlePosition();
    const classMap: Record<string, string> = {
      left: 'd-flex justify-content-between'
      // other positions can be added if needed in the future
    };

    return `mbs-form-group ${classMap[position] || ''}`;
  });

  protected readonly computedTitleClasses = computed<string>(() => {
    const host = 'mbs-form-group_title';
    const titleClasses = this.titleClasses();

    return titleClasses ? `${host} ${titleClasses}` : host;
  });

  protected readonly computedContentClasses = computed<string>(() => {
    const host = 'mbs-form-group_content';
    const customClass = this.contentCustomClass();

    return customClass ? `${host} ${customClass}` : host;
  });
}
